/**
 * Slick slider initialization.
 * @type {Window.jQuery|jQuery|HTMLElement|*}
 */
const $ = window.jQuery;
const SLICK_SLIDER_CUSTOM_CLASS = '.uri-slick-slider';
const SLICK_SLIDER_SLIDE_SHOW_XL = 3;
const SLICK_SLIDER_SLIDE_SHOW_MD = 1;
const SLICK_SLIDER_BREAKPOINT = 992;

export default {
  attach: function (context, _) {
    let $newContent = $(context);
    let $customSliders = $newContent.find(SLICK_SLIDER_CUSTOM_CLASS);

    // only custom sliders
    if ($customSliders.length > 0) {
      // Loop trough results.
      $customSliders.each(function(index, sliderContent){
        let $viewContent = $(sliderContent).find('.view-content');

        // Init slick slider.
        if($viewContent.length > 0) {
          Drupal.behaviors.slickSlider.initSlickSlider($viewContent);
        }
      });
    }

    // for all sliders
    Drupal.behaviors.slickSlider.translateSliderCount($newContent);

    // Append aria-live region
    Drupal.behaviors.slickSlider.appendAriaLive();

    $newContent.on('afterChange', function(event, slick, currentSlide){
      // Fix for dots focus when using the keyboard arrows, on after slide change
      let focusedDot = -1;

      if (slick.$dots !== null) {
        slick.$dots.find('> li').each(function(index) {
          if ($(this).find('> button').is(':focus')) {
            focusedDot = index;
          }
        });

        if (focusedDot !== -1) {
          if (slick.$dots.find('> li.slick-active > button').not(':focus')) {
            slick.$dots.find('> li.slick-active > button').focus();
          }
        }
      }

      // Screen reader announcement for the active slide title in the aria-live region
      slick.$slides.each(function() {
        if ($(this).hasClass('slick-active')) {
          if ($(this).find('.slide__link .slide__text h2').length) {
            $(this).closest('.paragraph-slideshow-wrapper').find('.liveregion').text(
              $(this).find('.slide__link .slide__text h2').text()
            );
          }
          else if ($(this).find('.slide__link .slide__text h3').length) {
            $(this).closest('.paragraph-slideshow-wrapper').find('.liveregion').text(
              $(this).find('.slide__link .slide__text h3').text()
            );
          }
        }
      });
    });
  },

  /**
   * Init slick slider.
   * @param $slider (items wrapper element)
   */
  initSlickSlider:function ($slider) {

    $slider.slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: SLICK_SLIDER_SLIDE_SHOW_XL,
      slidesToScroll: SLICK_SLIDER_SLIDE_SHOW_XL,
      arrows: false,
      appendDots: SLICK_SLIDER_CUSTOM_CLASS,
      responsive: [
        {
          // For MD breakpoint.
          breakpoint: SLICK_SLIDER_BREAKPOINT,
          settings: {
            slidesToShow: SLICK_SLIDER_SLIDE_SHOW_MD,
            slidesToScroll: SLICK_SLIDER_SLIDE_SHOW_MD,
          }
        }
      ]
    });
  },

  appendAriaLive:function () {
    $(document).ready(function() {
      $(document).find('.paragraph-slideshow-wrapper').each(function() {
        let liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.setAttribute('class', 'liveregion visually-hidden');
        $(this).append(liveRegion);

        $(this).find('.paragraph-slideshow .slick-slider').each(function(indexSlider) {
          let $slides = $(this).find('.slick-track .slick-slide:not(.slick-cloned)');

          $slides.each(function(indexSlide) {
            let $dot = $(this).closest('.paragraph-slideshow').find('ul.slick-dots li:nth-of-type(' + (indexSlide + 1) + ')');
            let $button = $dot.find('button');
            let $headline;
            if ($(this).find('.slide__text h2').length) {
              $headline = $(this).find('.slide__text h2');
            }
            else if ($(this).find('.slide__text h3').length) {
              $headline = $(this).find('.slide__text h3');
            }
            else if ($(this).find('.slide__text .slide__text__sub').length) {
              $headline = $(this).find('.slide__text .slide__text__sub');
            }

            $headline.attr('id', 'slider_headline_' + indexSlider + '_' + indexSlide);
            $button.attr('aria-describedby', 'slider_headline_' + indexSlider + '_' + indexSlide);
            $button.removeAttr('aria-label');
          });
        });
      });

      $(document).find('.paragraph-view-reference-display-press-slider').each(function(index) {
        let $headline = $(this).find('.paragraph__header h2');
        let $dots = $(this).find('.slick-dots');
        $headline.attr('id', 'slider_headline_' + index);
        $dots.attr('aria-labelledby', 'slider_headline_' + index);
      });
    });
  },

  translateSliderCount: function() {
    $(document).ready(function () {
      let $slickDots = $(document).find('.slick-dots li button');

      if ($slickDots.length > 0) {
        $slickDots.each(function (index, slickDot) {
          let $ariaLabel = slickDot.getAttribute('aria-label');
          if ($ariaLabel) {
            $ariaLabel = $ariaLabel.replace(/of/g, "von");
            slickDot.setAttribute('aria-label', $ariaLabel);
          }
        });
      }

      let $slickArrows = $(document).find('.slick__arrows');
      if ($slickArrows.length > 0) {
        $slickArrows.each(function (index, slickArrowsWrapper) {
          $(slickArrowsWrapper).find('.slick-prev').attr('aria-label', 'Zurück');
          $(slickArrowsWrapper).find('.slick-next').attr('aria-label', 'Weiter');
        });
      }
    });
  }
}
